import { render, staticRenderFns } from "./AsideInfo.vue?vue&type=template&id=07877304&functional=true&"
import script from "./AsideInfo.vue?vue&type=script&lang=js&"
export * from "./AsideInfo.vue?vue&type=script&lang=js&"
import style0 from "./AsideInfo.vue?vue&type=style&index=0&id=07877304&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports